<template>
  <el-row>
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-input
          clearable
          v-model="keyword"
          @input="searchHandle"
          placeholder="搜索关键字(姓名、手机号)"
          prefix-icon="el-icon-search"
          style="width:300px">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="level"
          placeholder="请选择"
          @change="searchHandle"
          clearable
          style="width:140px">
          <el-option
            v-for="(item,index) in userGroup"
            :key="index"
            :label="item.name"
            :value="item.level">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="searchHandle">搜索</el-button>
        <el-button type="primary" icon="el-icon-download">导出</el-button>
      </el-form-item>
    </el-form>
    <el-button-group>
      <el-button icon="el-icon-plus" size="small">添加到</el-button>
      <el-button icon="el-icon-message" size="small">通知</el-button>
      <el-button icon="el-icon-star-off" size="small">标记</el-button>
    </el-button-group>
    <table-component
      :table-data="tableData"
      :page="page"
      :total="total"
      :size="per_page"
      @current-change="currentPageChange"
      @selection-change="selectionChange"
      :contextmenu="tableContextMenu()">
    </table-component>

    <el-dialog title="设置VIP会员" :visible.sync="dialogVisible" width="800px">
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="VIP类型" prop="title">
          <el-select v-model="form.level" placeholder="下拉选择" style="width: 400px">
            <el-option :value="1" label="普通用户">普通用户</el-option>
            <el-option :value="3" label="CEF会员">CEF会员</el-option>
            <el-option :value="5" label="理事会员">理事会员</el-option>
          </el-select>
          <!-- <el-input v-model="form.title" placeholder="下拉选择" style="width: 400px"></el-input> -->
        </el-form-item>
        <el-form-item label="开始时间" prop="weight">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.vip_start_at" placeholder="选择时间" style="width: 400px"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="weight">
          <el-date-picker value-format="yyyy-MM-dd" v-model="form.vip_end_at" placeholder="选择时间" style="width: 400px"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="submit">确 定</el-button> -->
        <el-button type="primary" @click="saveChange">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置机构VIP会员" :visible.sync="dialog2Visible" width="800px">
      <el-form ref="form" label-width="90px">
        <partnerVips @close="closeDialog" :uuid="current.uuid"></partnerVips>
      </el-form>
  </el-dialog>


  </el-row>



</template>
<script>
import TableComponent from '@/components/Table'
import request from '@/utils/request'

import partnerVips from "@/components/partnerVips"

export default {
  name: 'UserList',
  data () {
    return {
      current: {},
      page: 1,
      total: 0,
      userList: [],
      per_page: 15,
      keyword: '',
      level: '',
      userGroup: [],
      dialogVisible: false,
      dialog2Visible: false,
      form: {

      }
    }
  },
  components: {
    TableComponent,
    partnerVips
  },
  mounted () {
    let _this = this
    // 获取用户分组
    request({
      url: 'user-levels',
      method: 'get'
    }).then(res => {
      let arr = res.data.levels
      arr.unshift({
        level: '',
        name: '所有会员'
      })
      _this.userGroup = arr
    })
    this.getUserList()
  },
  methods: {
    closeDialog () {
      this.dialog2Visible = false
      this.getUserList()
    },
    saveChange () {
      request({
        url: `users/${this.current.uuid}`,
        method: 'PATCH',
        data: {
          type: 'update', 
          attributes: this.form
        }
      }).then(res => {
        this.$message.success('设置成功!')
        this.getUserList()
        this.dialogVisible = false
      })
    },
    // page 变化
    currentPageChange (page) {
      this.page = page
      this.getUserList()
    },
    // 获取用户列表
    getUserList () {
      let sendData = {
        per_page: this.per_page,
        page: this.page,
        key: this.keyword,
        level: this.level
      }
      let _this = this
      request({
        url: 'users',
        method: 'get',
        params: sendData
      }).then(res => {
        // console.log(res)
        _this.total = res.data.item_total
        _this.userList = res.data.list
      })
    },
    // admin 选择用户 -- checkbox 变化
    selectionChange (list) {
      console.log(list)
    },
    // 搜索
    searchHandle () {
      this.page = 1
      this.getUserList()
    },
    tableContextCallback (item, type) {
      // console.log(item, type)
      switch (type) {
        case 'detail':
          this.$userLayer.show(item)
          break
      }
    },
    // table列表右键菜单
    tableContextMenu () {
      return {
        data: '',
        callback: this.tableContextCallback,
        menulist: [
          {
            label: '详情信息',
            type: 'detail'
          },
          {
            label: '删除',
            type: 'delete'
          }
        ]
      }
    }
  },
  computed: {
    tableData: function () {
      let _this = this
      return {
        props: [
          {
            label: '头像',
            type: 'img',
            prop: 'headimg',
            width: '50'
          },
          {
            label: '名称',
            type: 'string',
            prop: 'name',
            width: '100',
            clicked (item) {
              _this.$userLayer.show(item)
            },
            style: {
              color: '#409EFF',
              cursor: 'pointer'
            }
          },
          {
            label: '性别',
            type: 'string',
            prop: 'gender',
            width: '50'
          },
          {
            label: '城市',
            type: 'string',
            width: '100',
            prop: 'city'
          },
          {
            label: '手机号',
            type: 'string',
            width: '100',
            prop: 'phone'
          },
          {
            label: '积分',
            type: 'string',
            width: '50',
            prop: 'score'
          },
          {
            label: '会员等级',
            type: 'string',
            width: '80',
            prop: 'level_text'
          },
          {
            label: '注册日期',
            // type: 'time',
            width: '150',
            change: (item) => {
              return item.created_at.substr(0, 16)
            },
          },
          {
            label: '活跃于',
            type: 'time_day',
            prop: 'last_active_at',
            width: '100',
          },
          {
            label: '操作',
            change: (item) => {
              // if (item.level !== 5) {
                return '设置平台会员'
              // }
              // else {
              //     return '取消会员'
              // }
            },
            clicked: (item) => {
              this.current = item

              this.form = {
                level: item.level,
                vip_start_at: item.vip_start_at,
                vip_end_at: item.vip_end_at
              }
              this.dialogVisible = true
              return false

              let attributes = {
                    level: 5,
                    vip_start_at: '2020-01-01 00:00:00',
                    vip_end_at: '2022-01-01 00:00:00'
                  }

              if (item.level === 5) {
                  attributes = {
                    level: 1,
                    vip_start_at: null,
                    vip_end_at: null
                  }
              }

              request({
                url: 'users/' + item.uuid,
                method: 'PATCH',
                data: {
                  type: 'update',
                  attributes: attributes
                }
              }).then(res => {
                // console.log(res)
                this.$message.success('设置成功!')
                this.getUserList()
              })
            },
            style: {
              color: '#409EFF',
              cursor: 'pointer'
            }
          },
          {
            label: '操作',
            change: (item) => {
              // if (item.level !== 5) {
                return '设置机构会员'
              // }
              // else {
              //     return '取消会员'
              // }
            },
            clicked: (item) => {
              this.current = item
              this.dialog2Visible = true
              return false
            },
            style: {
              color: '#409EFF',
              cursor: 'pointer'
            }
          }
        ],
        list: this.userList,
        selection: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/list.vue